import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Url } from '@environment';
import { BehaviorSubject, Observable } from "rxjs";
import { bufferCount } from "rxjs/operators";
import jwt_decode from 'jwt-decode';
@Injectable()
export class XAuthService {

    eventAlertaSesion = new BehaviorSubject<any>(null);
    eventSesionState = new BehaviorSubject<any>(null);
    internetStatus: string;

    constructor(public http: HttpClient) { }

    async validarXToken(token: string) {
        const headers = {
            headers: { 'X-Authorization': `Bearer ${token}` }
        }
        const url = `${Url}/auth/tokenizer/validar-token`;
        return await this.http.post(url, {}, headers).toPromise();
    }

    async generarXToken(data: any) {
        const url = `${Url}/auth/tokenizer/crear-token-asesor`;
        return await this.http.post(url, { inputData: data }).toPromise();
    }

    async borrarXToken(token: string) {
        const url = `${Url}/auth/tokenizer/eliminar-token`;
        return await this.http.post(url, { xtoken: token }).toPromise();
    }

    async procesarXToken(loginInfo: any) {
        const { xAuthResponse, token, tokenData } = loginInfo;
        if (xAuthResponse) {
            const { legacyToken, token } = xAuthResponse;
            const tokenInfo: any = await this.validarXToken(token);
            if (tokenInfo.response) {
                return { token: legacyToken, xtoken: token, tokenData };
            }
            throw 'INVALID X TOKEN - NO SE PUDO VALIDAR (xAuthResponse)';
        }
        const jwtData: any = jwt_decode(token);
        return { token: token, xtoken: null, tokenData: jwtData };
    }

    obMultipleSesions() {
        return {
            get: () => this.eventAlertaSesion.asObservable().pipe(bufferCount(1)),
            set: (value) => this.eventAlertaSesion.next(value)
        }
    }

    obSesionState() {
        return {
            set: (data: any) => this.eventSesionState.next(data),
            get: (): Observable<any> => this.eventSesionState.asObservable().pipe(bufferCount(1)),
        };
    }

    wait(seconds:number){
        return new Promise(resolve => setTimeout(resolve, seconds * 1000));
      }

    validarConexionInternet() {
        return new Promise(async (resolve, reject) => {
            let intentos = 0;
            await this.obtenerEstatusConexion(0);
            if (this.internetStatus === 'ONLINE') return resolve(this.internetStatus);
            for (let i = 0; i < 11; i++) {
                await this.wait(5);
                await this.obtenerEstatusConexion(intentos + 1);
                if (this.internetStatus === 'ONLINE') {
                    resolve(this.internetStatus);
                    break;
                }
                intentos++;
            }
            return reject(null);
        });
    }

    async obtenerEstatusConexion(intento) {
        try {
            await this.validarConexionValidador();
            this.internetStatus = 'ONLINE';
            console.log(`[VALIDADOR CONEXIÓN SERVIDOR - INTERNET] - ` + this.internetStatus);
        } catch (err) {
            this.internetStatus = 'OFFLINE';
            console.log(`[VALIDADOR CONEXIÓN SERVIDOR - INTERNET] - INTENTO [${intento}] - ` + this.internetStatus);
        }
        return this.internetStatus;
    }

    async validarConexionValidador() {
        const url = `${Url}/auth/healthz`;
        return await this.http.get(url, {}).toPromise();
    }
}